import React from 'react'
import PropTypes from 'prop-types'
import Component from 'decorators/Component'
import Dialog from './Dialog'

const buttonTypes = {
  cancel: 'cancel',
  confirm: 'confirm'
}

class TransactionalDialog extends React.PureComponent {
  static propTypes = {
    show: PropTypes.bool,
    onClose: PropTypes.func,
    onClosed: PropTypes.func,
    header: PropTypes.any,
    body: PropTypes.any,
    subText: PropTypes.any,
    confirmText: PropTypes.string,
    cancelText: PropTypes.string,
    onConfirm: PropTypes.func,
    onCancel: PropTypes.func,
    initialFocus: PropTypes.string
  }

  static defaultProps = {
    show: false,
    onClose: () => {},
    onConfirm: x => x,
    onCancel: x => x
  }

  state = {
    cancelling: false,
    confirming: false
  }

  componentDidMount () {
    if (this.props.show) {
      document.addEventListener('keyup', this.handleKeyPress)
    }
  }

  componentDidUpdate (prevProps) {
    if (!prevProps.show && this.props.show) {
      document.addEventListener('keyup', this.handleKeyPress)
    } else if (!this.props.show && prevProps.show) {
      document.removeEventListener('keyup', this.handleKeyPress)
    }
  }

  componentWillUnmount () {
    document.removeEventListener('keyup', this.handleKeyPress)
  }

  handleKeyPress = (e) => {
    if (e.keyCode === 13) {
      const { onConfirm } = this.props
      this.handleButtonClick(onConfirm)
    }
  }

  handleAsyncButtonClick = async (action, buttonType) => {
    const { onClose } = this.props
    if (buttonType === buttonTypes.confirm) {
      this.setState({ confirming: true })
    } else if (buttonType === buttonTypes.cancel) {
      this.setState({ cancelling: true })
    }

    await action()
    this.setState({ confirming: false, cancelling: false })
    onClose()
  }

  onCancelButtonClick = async () => {
    const { onCancel } = this.props
    await this.handleAsyncButtonClick(onCancel, buttonTypes.cancel)
  }

  onConfirmButtonClick = async () => {
    const { onConfirm } = this.props
    await this.handleAsyncButtonClick(onConfirm, buttonTypes.confirm)
  }

  render () {
    const { confirming, cancelling } = this.state
    const { t, confirmText, cancelText, initialFocus, ...props } = this.props

    return (
      <Dialog
        {...props}
        initialFocus={initialFocus || '#confirmButton'}
        buttons={(
          <React.Fragment>
            <Dialog.Button
              secondary
              loading={cancelling}
              disabled={confirming || cancelling}
              id='cancelButton'
              type='button'
              onClick={this.onCancelButtonClick}>
              {cancelText || t('Cancel')}
            </Dialog.Button>
            <Dialog.Button
              id='confirmButton'
              loading={confirming}
              disabled={confirming || cancelling}
              onClick={this.onConfirmButtonClick} >
              {confirmText || t('Confirm')}
            </Dialog.Button>
          </React.Fragment>
        )} />
    )
  }
}

export default Component()(TransactionalDialog)
